// extracted by mini-css-extract-plugin
export default {"Status":"Record_Status__nGED7"};